import { IBasket } from "Domain/Model/BasketEntry/BasketEntry";

export const ADD_TO_BASKET = 'ADD_TO_BASKET';

export const addToBasket = (payload: IBasket) => ({
    type: ADD_TO_BASKET,
    payload,
})